import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private readonly http: HttpClient) {}

  manualCheckForNotifications(currentTime?: string) {
    return this.http.post<{ status: string }>(`${environment.apiUrl}/api/private/notifications/check`, {
      currentTime
    });
  }
}
